((function(){

    document.addEventListener('adev:quick-add:init', function(e){

        document.querySelectorAll('[data-adev-pgi-form="true"]:not(.adev-init)').forEach(function(formEl){
            formEl.classList.add('adev-init');

            formEl.addEventListener('submit', function(e){
                e.preventDefault();

                const quantityEl = formEl.querySelector('[data-adev-quantity-selector="input"]');
                const quantity = quantityEl.value;

                if(quantity < 1){
                    alert('Please select a quantity greater than 0.');
                    return;
                }

                const addToCartEl = formEl.querySelector('[data-adev-pgi-add-to-cart]');
                addToCartEl.disabled = true;
                addToCartEl.classList.add('loading');

                const formData = new FormData(formEl);
               
                formData.append('sections', 'adev-cart-drawer');

                fetch('/cart/add.js', {
                        method: 'POST',
                        body: formData,
                })
                .then(response => response.json())
                .then(data => {
                    
                    if (typeof data === 'object' && data.sections && data.sections['adev-cart-drawer']) {
                        document.dispatchEvent(new CustomEvent('adev:cart:drawer:refresh', {
                            detail: data.sections['adev-cart-drawer']
                        }));

                        addToCartEl.disabled = false;
                        addToCartEl.classList.remove('loading');

                        setTimeout(function(){
                            const cartLink = document.querySelector('[data-open-drawer="cart-drawer"]');
                            if(cartLink){
                                cartLink.click();
                            }
                        }, 200);
                    }

                })
                .catch((error) => {
                    console.error('Error:', error);
                    addToCartEl.disabled = false;
                    addToCartEl.classList.remove('loading');
                });

            });

        });

        document.querySelectorAll('[data-adev-quantity-selector="wrap"]:not(.adev-init)').forEach(function(el){
            el.classList.add('adev-init');

            const inputEl = el.querySelector('[data-adev-quantity-selector="input"]');
            const incrementEl = el.querySelector('[data-adev-quantity-selector="up"]');
            const decrementEl = el.querySelector('[data-adev-quantity-selector="down"]');

            const min = 0;
            const max = incrementEl.getAttribute('max') || 1000;

            incrementEl.addEventListener('click', function(e){
                e.preventDefault();
                let value = parseInt(inputEl.value);
                if(value < max){
                    inputEl.value = value + 1;
                    inputEl.dispatchEvent(new Event('change'));
                }
            });

            decrementEl.addEventListener('click', function(e){
                e.preventDefault();
                let value = parseInt(inputEl.value);
                if(value > min){
                    inputEl.value = value - 1;
                    inputEl.dispatchEvent(new Event('change'));
                }
            });

        });

    });

    document.dispatchEvent(new CustomEvent('adev:quick-add:init'));

    document.addEventListener('adev:related_section:loaded', function(e){
        document.dispatchEvent(new CustomEvent('adev:quick-add:init'));
    });

})());